<p-dialog
    [header]="gameSignal() ? 'Variants of ' + effectiveTitle(gameSignal()!) : 'Variants'"
    [visible]="visibleSignal()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '72rem' }"
    [breakpoints]="{ '1400px': '95vw' }"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
>
    @if (gameSignal(); as g) {
        <div class="flex flex-col gap-3">
            <div class="text-sm text-muted-color">
                Game ID: {{ g.Id }}
            </div>

            @if (variantsService.error()) {
                <p-message severity="error" [text]="variantsService.error()!" />
            }

            <p-table
                [value]="filteredVariants()"
                [loading]="variantsService.loading()"
                dataKey="GameVariantId"
                [rowTrackBy]="trackById"
                [rows]="10"
                [paginator]="true"
                [showGridlines]="true"
                responsiveLayout="scroll"
            >
                <ng-template #caption>
                    <div class="flex items-center justify-between gap-3 flex-wrap">
                        <div class="flex items-center gap-2">
                            <p-button
                                label="Add variant"
                                icon="pi pi-plus"
                                size="small"
                                (onClick)="openAdd()"
                            />
                            <p-button
                                label="Refresh"
                                icon="pi pi-refresh"
                                severity="secondary"
                                outlined
                                size="small"
                                [loading]="variantsService.loading()"
                                (onClick)="refresh()"
                            />
                        </div>
                        <p-iconfield class="ml-auto">
                            <p-inputicon styleClass="pi pi-search" />
                            <input
                                pInputText
                                type="text"
                                placeholder="Search variants…"
                                [ngModel]="searchTerm()"
                                (ngModelChange)="searchTerm.set($event ?? '')"
                            />
                        </p-iconfield>
                    </div>
                </ng-template>
                <ng-template #header>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Players</th>
                        <th>Entry Fee</th>
                        <th>Reward (1st)</th>
                        <th>Status</th>
                        <th style="width: 6rem">Actions</th>
                    </tr>
                </ng-template>
                <ng-template #body let-v>
                    <tr>
                        <td>
                            <div class="flex flex-col">
                                <span class="font-medium">{{ effectiveVariantDisplayInfo(v).Name }}</span>
                                @if (effectiveVariantDisplayInfo(v).Description) {
                                    <span class="text-xs text-muted-color line-clamp-1">{{ effectiveVariantDisplayInfo(v).Description }}</span>
                                }
                            </div>
                        </td>
                        <td class="text-sm">{{ modeConfigTypeLabel(v.Template.ModeConfig) }}</td>
                        <td class="text-sm">
                            @if (variantPlayerCount(v.Template.ModeConfig); as count) {
                                <span class="inline-flex items-center gap-1">
                                    <i class="pi pi-users text-xs"></i>{{ count }}
                                </span>
                            } @else {
                                <span class="text-muted-color">—</span>
                            }
                        </td>
                        <td class="text-sm">
                            @switch (variantEntryFee(v.Template.ModeConfig).kind) {
                                @case ('fixed') {
                                    <app-funds-display [funds]="$any(variantEntryFee(v.Template.ModeConfig)).funds" />
                                }
                                @case ('range') {
                                    {{ $any(variantEntryFee(v.Template.ModeConfig)).min }}–{{ $any(variantEntryFee(v.Template.ModeConfig)).max }}
                                    <span class="text-muted-color">({{ $any(variantEntryFee(v.Template.ModeConfig)).currency }})</span>
                                }
                                @default { <span class="text-muted-color">—</span> }
                            }
                        </td>
                        <td class="text-sm">
                            @if (variantTopReward(v.Template.ModeConfig); as r) {
                                <span class="inline-flex items-center gap-1">
                                    <i class="pi pi-trophy text-xs"></i>
                                    <app-funds-display [funds]="r" />
                                </span>
                            } @else {
                                <span class="text-muted-color">—</span>
                            }
                        </td>
                        <td>
                            @if (effectiveVariantIsActive(v)) {
                                <p-tag value="Active" severity="success" />
                            } @else {
                                <p-tag value="Inactive" severity="secondary" />
                            }
                        </td>
                        <td>
                            <p-button
                                icon="pi pi-pencil"
                                severity="warn"
                                [rounded]="true"
                                [outlined]="true"
                                pTooltip="Edit"
                                (onClick)="openEdit(v)"
                            />
                        </td>
                    </tr>
                </ng-template>
                <ng-template #emptymessage>
                    <tr>
                        <td colspan="7" class="text-center py-8 text-muted-color">
                            No variants configured for this game.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <app-add-variant-dialog
            [visible]="addDialogVisible()"
            (visibleChange)="addDialogVisible.set($event)"
            (templateSelected)="onTemplateSelected($event)"
            [realmId]="g.RealmId"
            [gameId]="g.Id"
        />

        <app-configure-variant-dialog
            [visible]="configureDialogVisible()"
            (visibleChange)="configureDialogVisible.set($event)"
            (created)="onVariantCreated()"
            [realmId]="g.RealmId"
            [gameId]="g.Id"
            [template]="selectedTemplate()"
            [gameTitleOverride]="g.Overrides.Title"
        />

        <app-edit-variant-dialog
            [visible]="editDialogVisible()"
            (visibleChange)="editDialogVisible.set($event)"
            [realmId]="g.RealmId"
            [gameId]="g.Id"
            [adminVariant]="editingVariant()"
        />
    }

    <ng-template #footer>
        <div class="flex justify-end">
            <p-button label="Close" severity="secondary" (onClick)="close()" />
        </div>
    </ng-template>
</p-dialog>
